import React from 'react'
import Teaser from '../Teaser'

const QuickAppointmentTeaser = (props) =>
  <Teaser { ...props } />

export default QuickAppointmentTeaser
